import React, { Component } from "react";
import {
  GetOrderDetails,
  GetPaymentDetails,
  GetCustomerDetails,
  GetProductDetails,
} from "../../services";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import Footer from "../footer"

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCustomers: 0,
      totalProducts: 0,
      totalOrders: 0,
      totalIncome: 0,
      customersData: [],
      topSellersData: [],
      customersDataMonthwise: [],
      dailypaymentsData: [],
      monthlypaymentsData: [],
      yearlyPaymentsData: [],
      dailySalesData: [],
      monthlySalesData: [],
      yearlySalesData: [],
    };
  }

  async componentDidMount() {
    try {
      // Fetch order count
      const orderData = await GetOrderDetails.getOrderCount();
      if (orderData) {
        this.setState({
          totalOrders: orderData.totalOrders || 0,
          dailySalesData: orderData.dailySalesData || [],
          monthlySalesData: orderData.monthlySalesData || [],
          yearlySalesData: orderData.yearlySalesData || [],
          topSellersData: orderData.top5Products || [],
        });
      }

      const incomeData = await GetPaymentDetails.getTotalIncome();
      if (incomeData && incomeData.totalIncome) {
        this.setState({
          totalIncome: incomeData.totalIncome.toFixed(2),
          dailypaymentsData: incomeData.dailySales || [],
          monthlypaymentsData: incomeData.monthlySales || [],
          yearlyPaymentsData: incomeData.yearlySales || [],
        });
      }

      // Fetch customer count data
      const customercount = await GetCustomerDetails.getCustomerCount();
      if (
        customercount &&
        customercount.success &&
        customercount.customersData
      ) {
        this.setState({
          totalCustomers: customercount.totalCustomers || 0,
          customersData: customercount.customersData || [],
          customersDataMonthwise: customercount.CustomersDatamonthwise || [],
        });
      }

      // Fetch product count
      const Productcount = await GetProductDetails.getProductCount();
      if (Productcount && Productcount.totalProducts) {
        this.setState({
          totalProducts: Productcount.totalProducts || 0,
        });
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  }

  render() {
    const {
      totalOrders,
      totalIncome,
      totalCustomers,
      totalProducts,
      customersData,
      customersDataMonthwise,
      dailypaymentsData,
      monthlypaymentsData,
      yearlyPaymentsData,
      dailySalesData,
      monthlySalesData,
      yearlySalesData,
      topSellersData,
    } = this.state;
    return (
      <div id="layoutSidenav_content">
        <main>
          <div className="container-fluid">
            <h2 className="mt-30 page-title">Dashboard</h2>
            <ol className="breadcrumb mb-30">
              <li className="breadcrumb-item active">Dashboard</li>
            </ol>
            <div className="row">
              <div className="col-xl-3 col-md-6">
                <div className="dashboard-report-card purple">
                  <div className="card-content">
                    <span className="card-title">Total Orders</span>
                    <span className="card-count">{totalOrders}</span>
                  </div>
                  <div className="card-media">
                    <i className="fas fa-shopping-cart rpt_icon" />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="dashboard-report-card red">
                  <div className="card-content">
                    <span className="card-title">Total Products</span>
                    <span className="card-count">{totalProducts}</span>
                  </div>
                  <div className="card-media">
                    <i className="fas fa-box-open rpt_icon" />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="dashboard-report-card info">
                  <div className="card-content">
                    <span className="card-title">Total Customers</span>
                    <span className="card-count">{totalCustomers}</span>
                  </div>
                  <div className="card-media">
                    <i className="fas fa-users rpt_icon" />
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="dashboard-report-card success">
                  <div className="card-content">
                    <span className="card-title">Total Income</span>
                    <span className="card-count">₹{totalIncome}</span>
                  </div>
                  <div className="card-media">
                    <i className="fas fa-money-bill rpt_icon" />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* New Customers Added (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">New Customers Added</div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={customersData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="period" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="customers" fill="#26c6da" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              {/* New Customers Added Month wise (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">
                    New Customers Added Month wise of current Year
                  </div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={customersDataMonthwise}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="period" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="customers" fill="#26c" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>

              {/* Daily Payments Report (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">Daily Payment Report</div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={dailypaymentsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="day" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="Total Amount"
                          stroke="#ab47bc"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>

              {/* Monthly Payments Report (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">
                    Monthly Payment Report - Current Year
                  </div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={monthlypaymentsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="Total Amount" fill="#42a5f5" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>

              {/* Yearly Payment Report (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">Yearly Payment Report</div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={yearlyPaymentsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="year" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="Total Amount" fill="#ff7043" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>

              {/* Daily Sales Report (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">Daily Sales Report</div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={dailySalesData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="day" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="sales"
                          stroke="#ab47bc"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>

              {/* Monthly Sales Report (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">
                    Monthly Sales Report - Current Year
                  </div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={monthlySalesData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="sales" fill="#42a5f5" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>

              {/* Yearly Sales Report (Bar Chart) */}
              <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">Yearly Sales Report</div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={yearlySalesData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="year" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="sales" fill="#ff7043" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>

                 {/* Top Sellers Report (Bar Chart) */}
                 <div className="col-xl-6 col-md-12">
                <div className="card">
                  <div className="card-header">Top Sellers Report</div>
                  <div className="card-body">
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={topSellersData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="sales" fill="rgb(41, 232, 41)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer/>
        {/* <footer className="py-4 bg-footer mt-auto">
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-between small">
              <div className="text-muted-1">
                © 2024 <b>JC Creations</b>.
              </div>
              <div className="footer-links">
                <a
                  target="blank"
                  href="https://jc-creations.in/privacy-policy"
                >
                  Privacy Policy
                </a>
                <a
                  target="blank"
                  href="https://jc-creations.in/terms-and-conditions"
                >
                  Terms &amp; Conditions
                </a>
              </div>
            </div>
          </div>
        </footer> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/index.js